/**
 * RecommendedUsers 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const RecommendedUsersProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '피추천인 목록'
      },
      {
        name: 'componentProps.emptyText',
        label: '데이터 없음 메시지',
        control: 'TextField',
        defaultValue: '데이터가 없습니다'
      },
      {
        name: 'componentProps.loadingText',
        label: '로딩 메시지',
        control: 'TextField',
        defaultValue: '로딩 중...'
      },
      {
        name: 'componentProps.loginRequiredText',
        label: '로그인 필요 메시지',
        control: 'TextField',
        defaultValue: '로그인이 필요합니다.'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'style.maxWidth',
        label: '최대 너비',
        control: 'TextField',
        defaultValue: '800px'
      },
      {
        name: 'style.margin',
        label: '마진',
        control: 'TextField',
        defaultValue: '20px auto'
      }
    ]
  }
];

export default RecommendedUsersProperties; 